import React from 'react';
import { generateContent } from '../../helpers/plunger';

const ListItem = props => {
  const { columns, data } = props;

  return (
    <div className={`cms__details-bar ${props.className || ''}`}>
      {renderColumns(data, columns)}
    </div>
  );
};

const renderColumns = (data, columns) => {
  if (!columns) return '';
  return columns.map((specs, i) => renderColumn(data, specs, i));
};

const renderColumn = (data, specs, i) => {
  const content = generateContent(data, specs);
  return (
    <div
      key={i}
      className={`p cms__details-bar-item ${specs.labelClass || ''}`}
    >
      <p className={`p p--bold ${specs.labelClass || ''}`}>
        {specs.label || ''}
      </p>
      <div className="p p--detail-garamond">{content}</div>
    </div>
  );
};

export default ListItem;



// WEBPACK FOOTER //
// ./src/components/shared/DetailsBar.js